import React from 'react';
import { Link } from 'react-router-dom';
import { useSeo } from '../utils/seo';

export default function TermsPolicy() {
  useSeo({
    title: 'Gigtos Terms of Service - Marketplace And Direct Payment Rules',
    description: 'Gigtos terms for consumers, workers, direct-pay MVP jobs, worker subscription access, referral free days, and marketplace responsibilities.',
    path: '/#/terms',
    keywords: 'Gigtos terms, Gigtos marketplace rules, direct payment, worker subscription, referral free access',
  });

  return (
    <main style={{ maxWidth: 980, margin: '0 auto', padding: '48px 24px 96px', color: 'var(--text-main)' }}>
      <section style={{
        border: '1px solid var(--border-light)',
        borderRadius: 8,
        background: 'var(--bg-surface)',
        padding: 28,
        boxShadow: 'var(--shadow-sm)',
      }}>
        <span style={{ color: 'var(--primary-purple)', fontWeight: 900, fontSize: 12, textTransform: 'uppercase' }}>
          Gigtos terms
        </span>
        <h1 style={{ margin: '8px 0 12px', letterSpacing: 0 }}>Terms of Service</h1>
        <p style={{ color: 'var(--text-muted)', lineHeight: 1.7 }}>
          Last updated: June 27, 2026. These terms describe how consumers, workers, and admins use Gigtos during MVP launch.
        </p>

        {[
          ['Marketplace Role', 'Gigtos helps consumers discover and book verified local service workers. Workers are independent service providers who use the platform to find work; Gigtos does not employ or hold workers as staff.'],
          ['Worker Subscription', 'Consumers do not pay a Gigtos subscription. Workers may receive free access first, then continue through a worker subscription plan that currently starts at INR 500 per month and may be updated by SuperAdmin.'],
          ['No Job Commission', 'For the current model, workers keep the customer job price. Gigtos does not deduct per-job commission from worker earnings.'],
          ['Direct Payment', 'Unless an online payment flow is explicitly shown for a booking, the consumer pays the worker directly after the work is completed and accepted.'],
          ['Referral Free Access', 'A worker can receive referral free-access days when a referred worker becomes active and completes eligible work. Referral free access is capped by platform rules.'],
          ['Safety And Verification', 'Gigtos can require profile proof, work photos, ratings, location checks, and manual review to protect consumers and workers. Access can be limited for fraud, abuse, unsafe behavior, or policy violations.'],
          ['Damage And Service Quality', 'Workers are independent providers. Gigtos supports review, dispute, and evidence workflows, but responsibility for on-site service conduct, damage, or service quality primarily remains with the service participants and applicable law.'],
          ['Contact Privacy', 'Gigtos may use masked calls, in-app chat, or relay contact details to reduce unnecessary phone exposure. Direct contact details may be shown only where platform rules allow it.'],
          ['Changes', 'Gigtos can update pricing controls, service rules, access rules, and safety policies as the marketplace grows. Important user-facing changes should be reflected in the app or admin controls.'],
        ].map(([title, body]) => (
          <section key={title} style={{ marginTop: 24 }}>
            <h2 style={{ margin: '0 0 8px', fontSize: 22 }}>{title}</h2>
            <p style={{ margin: 0, color: 'var(--text-muted)', lineHeight: 1.7 }}>{body}</p>
          </section>
        ))}

        <p style={{ marginTop: 24, color: 'var(--text-muted)', lineHeight: 1.7, fontSize: 13 }}>
          This page is an operational MVP terms page and should be reviewed by a qualified legal professional before broad paid launch.
        </p>

        <div style={{ marginTop: 30, display: 'flex', gap: 12, flexWrap: 'wrap' }}>
          <Link to="/services" style={{
            background: 'var(--primary-purple)',
            color: '#fff',
            textDecoration: 'none',
            borderRadius: 8,
            padding: '11px 16px',
            fontWeight: 900,
          }}>
            View Services
          </Link>
          <Link to="/privacy" style={{
            border: '1px solid var(--border-light)',
            color: 'var(--text-main)',
            textDecoration: 'none',
            borderRadius: 8,
            padding: '11px 16px',
            fontWeight: 900,
          }}>
            Privacy Policy
          </Link>
        </div>
      </section>
    </main>
  );
}
